<template>
    <div :class="{ login: true, appLogin: flag == 'app' }">
        <!-- <div class="header">
            <span class="fl">新时代家谱</span>
            <a href="javascript:;" class="fr">立即注册</a>
        </div> -->
        <!-- <num></num> -->
        <div id="admin">
            <!-- v-loading="loading" -->
            <div class="pos">
                <h1 class="adminh1">用户登录</h1>
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="用户名：" prop="pass">
                        <el-input prefix-icon="el-icon-user" placeholder="请输入您的手机号码" :class="{ appWidth: flag == 'app' }" style="width: 250px" type="text" v-model="ruleForm.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="密 码：" prop="checkPass">
                        <el-input
                            prefix-icon="el-icon-menu"
                            style="width: 250px" 
                            :class="{ appWidth: flag == 'app' }"
                            show-password
                            type="password"
                            v-model="ruleForm.checkPass"
                            placeholder="请输入密码8-12位"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="验证码：" prop="code">
                        <el-input prefix-icon="el-icon-menu"  :class="{ appWidth1: flag == 'app' }" style="width: 115px" type="text" v-model="ruleForm.code" autocomplete="off"></el-input>
                        <img :src="codescr" alt="" @click="captcha()" />
                    </el-form-item>
                    <el-form-item >
                        <el-checkbox v-model="ruleForm.remember" :true-label="1">30天免验证登陆</el-checkbox>
                    </el-form-item>
                    <el-form-item :class="{ appBut: flag == 'app' }">
                        <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
                        <el-button @click="register()">注册</el-button>
                        <el-button @click="retrieve()">找回密码</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/request/api";
//  import num from "@/components/num";
export default {
    name: "login",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入您的手机号码"));
            } else {
                if (this.ruleForm.checkPass !== "") {
                    this.$refs.ruleForm.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value.length < 8) {
                callback(new Error('密码长度至少8位'));
            } else if (value.length > 20) {
                callback(new Error('密码长度不能超过20位'));
            } else{
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入验证码"));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            codescr: "",
            ruleForm: {
                pass: "",
                checkPass: "",
                code: "",
                remember: 0
            },
            /*  pass: "13605312062",
                checkPass: "123456789", */
            rules: {
                pass: [{ validator: validatePass, trigger: "blur" }],
                checkPass: [{ validator: validatePass2, trigger: "blur" }],
                code: [{ validator: validateCode, trigger: "blur" }]
            },
            flag: (function() {
                var f = sessionStorage.getItem("flag");
                if (f) return f;
                return /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i.test(navigator.userAgent) ? "app" : "pc";
            })()
        };
    },
    mounted() {
        api.loginstatus().then((res) => {
            if (res.code == 0) {
                if (this.flag == "pc") {
                    this.$router.push("/family");
                } else {
                    this.$router.push("/mobileguide");
                }
            }
        });
        this.captcha();
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    api.login({
                        mobile: this.ruleForm.pass,
                        password: this.ruleForm.checkPass,
                        code: this.ruleForm.code,
                        remember: this.ruleForm.remember
                    }).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "登录成功",
                                type: "success"
                            });
                            sessionStorage.setItem("loginType", true);
                            setTimeout(() => {
                                if (this.flag == "pc") {
                                    this.$router.push("/family");
                                } else {
                                    this.$router.push("/mobileguide");
                                }
                                this.loading = false;
                            }, 1000);
                        } else {
                            this.captcha();
                            this.$message({
                                message: res.msg,
                                type: "warning"
                            });
                        }
                    });
                    this.loading = true;
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        captcha() {
            api.captcha("login").then((res) => {
                this.codescr = res.data;
            });
        },
        register() {
            this.$router.push("/register");
        },
        retrieve() {
            this.$router.push("/retrieve");
        }
    },
    components: {
        // num
    }
};
</script>
<style lang="less">
.login {
    width: 100%;
    height: 100%;
    background: url("../assets/img/bj_zhuce.jpg");
    .header {
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
    }

    #admin {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -200px;
        margin-left: -250px;
        width: 400px;
        height: auto;
        min-height: 400px;
        background: #fff;
        border-radius: 15px;
        border: 1px solid #f3f3f3;
    }
    .adminh1 {
        margin: 20px 10px;
        font-size: 20px;
    }
}
.appLogin {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    overflow-y: auto;

    #admin {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        margin: 20px auto !important;
        transform: none !important;
        width: 90% !important;
        .appWidth{
            width:90% !important;
        }
        .appWidth1{
            width:42% !important;
        }
        .appBut{
            >div{
                margin-left:0 !important;
                text-align: center !important;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue